import type { UserSubscription } from "../../../shared/types/servicePlans";

/**
 * Whether the user has a loaded wallet row from the API.
 * There are no subscription tiers: Stripe sells token packs only; this app gates on balance.
 */
export function isValidSubscription(
  subscription: UserSubscription | null | undefined,
): boolean {
  if (!subscription) {
    return false;
  }

  // Zero balance is still a valid wallet row; user can buy tokens. Do not treat as "no subscription".
  if (typeof subscription.tokensRemaining === "number") {
    return subscription.tokensRemaining >= 0;
  }

  return (
    subscription.status === "active" ||
    subscription.status === "pending"
  );
}
